import * as React from 'react'

import styled from 'styled-components/macro'
import Routes from 'common/Routes'

const Container = styled.div`
  height: 100%;
  width: 100%;
`

const Main = () => {
  // const origin = window.location.origin
  // const pathname = window.location.pathname

  // if (origin.includes('eams.att.temeda.com')) {
  //   window.location.replace(`https://eams.geoforce.com${pathname}`)
  // }
  // if (origin.includes('temeda') || origin.includes('ascendfleet')) {
  //   window.location.replace(`https://ascend.geoforce.com${pathname}`)
  // }
  return (
    <Container>
      <Routes />
    </Container>
  )
}
export default Main
